module.exports = {"TXTCLI_City":{"id":"TXTCLI_City","defaultMessage":"Város","flags":["TRACK"],"track":"City"}}